import {MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow} from "mdbreact"
import PassRateDetailsDateRangeFilter from "../../../components/PassRateReport/PassRateDetails/PassRateDetailsDateRangeFilter"
import DateRangeReportGrid from "../../../components/PassRateReport/PassRateDetails/PassRateReportDateRange"
import {useAppDispatch} from "../../../store"
import { useEffect } from "react"
import { getUserDealersAction } from "../../App/appSlice"


const PassRateDetails = () => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(getUserDealersAction("MULTIPLE_DEALER"))
    }, [dispatch])
    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem>Manage MOT</MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Pass Rates Details</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <PassRateDetailsDateRangeFilter />
            <MDBRow>
                <MDBCol md="12">
                    <MDBCard>
                        <MDBCardBody className="p-2">
                            <MDBCardTitle className="text-muted">Monthly Pass Rates</MDBCardTitle>
                            <DateRangeReportGrid />
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </>
    )
}

export default PassRateDetails
